import ConceptMapContainer from './ConceptMapContainer';

export default ConceptMapContainer;